function ez_headerWidth() {
    var header      = $('.ez_website-header'),
        workarea    = $('.ez_workarea').width();

    header.css({
        'max-width' :   workarea
    });
}